import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine, RiQrScan2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  openCreateStudent,
  openStudentReportModel,
  openUserQRCodeModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  getAllActiveStudentsRequest,
  deleteStudentRequest,
} from "../../../modules/superadmin-modules/students/Actions";
import { getAllGroupsRequest } from "../../../modules/superadmin-modules/groups/Actions";


const ActiveStudentsTable = ({ setAdd, setSelectedData, searchTerm, tab }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.superadminstudents.isLoading);
  const count = useSelector((state) => state.superadminstudents.count);
  const students = useSelector((state) => state.superadminstudents.students);
  const groups = useSelector((state) => state.superadminGroups.groups);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });

  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, [tab]);

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  useEffect(() => {
    const timeId = setTimeout(() => {
      if (tab == 0)
        dispatch(
          getAllActiveStudentsRequest({
            page: pageNumber + 1,
            name: searchTerm,
          })
        );
    }, 500);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, tab]);

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const Data = students?.items?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.enrollments?.length > 0 ? groupsOptions?.find((val) => val?.value == data?.enrollments[0]?.student_group_id)?.label : null,
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color={data?.deleted_at ? "green" : "red"}
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine />}
          onClick={() => {
            dispatch(deleteStudentRequest(data?.id));
          }}
        />
      ),
      code: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiQrScan2Line />}
          onClick={() => dispatch(openUserQRCodeModel())}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " #",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: " رقم الطالب",
      accessor: "phone",
    },
    {
      Header: "رقم المتابعة ",
      accessor: "mother_phone",
    },
    {
      Header: "Code",
      accessor: "code",
    },
    {
      Header: "اسم المستخدم",
      accessor: "user_name",
    },
    {
      Header: "المجموعة",
      accessor: "group_name",
    },
    {
      Header: "Major",
      accessor: "major.name_ar",
    },
    {
      Header: "Grade",
      accessor: "grade.name_ar",
    },
    {
      Header: "",
      accessor: "edit",
    },
    {
      Header: "suspend",
      accessor: "delete",
    },
  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        >
          تعديل
        </MenuItem>
      </MenuList>
    </Menu>
  );
  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data || []}
      path={"openModel"}
      Actions={actions}
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(count / 50)}
    />
  );
};

export default ActiveStudentsTable;
